import { Icon123 } from '@tabler/icons-react'

import { NAVIGATION_CONFIG } from '@/config/constants/navigation'

type IconProps = React.ComponentProps<typeof Icon123>

type NavIds = (typeof NAVIGATION_CONFIG)[number]['items'][number]['id']

export const getNavIcon = (id: NavIds, iconProps?: IconProps) => {
  for (const group of NAVIGATION_CONFIG) {
    for (const item of group.items) {
      if (item.id === id) {
        return <item.icon size={16} {...iconProps} />
      }
    }
  }

  return null
}
